export default "__VITE_ASSET__GgsuByGe__"